module.exports = __webpack_public_path__ + "static/media/2_1_sharmilan_rayer.a325965.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/2_1_sharmilan_rayer.mp3
// module id = imW0
// module chunks = 1